import React from 'react';
import ReactPaginate from 'react-paginate';

const Paginate = ReactPaginate;

export default Paginate;
